// extracted by mini-css-extract-plugin
module.exports = {"resetBtn":"t3ejk85zMkaCrE6jC-a0p","icon":"hoyCVFEa6PH3VAXe0RhmN","active":"_5gJNcV7-33QdPGsHdqIhg"};